import Vue from "vue";
import Router from "vue-router";
import SignIn from "./views/SignIn.vue";
import Forgot from "./views/Forgot.vue";
import Changed from "./views/Changed.vue";
import Home from "./views/Home.vue";
import ErrorMsg from "./views/ErrorMsg";
import Report from "./views/Report.vue";
import NativeReport from "./views/NativeReport.vue";
import DocView from "./views/DocView.vue";
import Order from "./views/Order.vue";
import RMALabel from "./views/RMALabel.vue";
import CSVOrder from "./views/CSVOrder.vue";
import ImageView from "./views/ImageView.vue";
import CustomReport from "./views/CustomReport.vue";
import COD from "./views/COD.vue";
import store from "./store";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [{
        path: "/",
        name: "home",
        alias: ["/index.html", "/logout"],
        component: Home,
        meta: {
            title: "QGistix Portal",
            auth: false,
        },
    },
    {
        path: "/login",
        name: "login",
        component: SignIn,
        meta: {
            title: "QGistix Portal",
            auth: false,
        },
    },
    {
        path: "/forgot",
        alias: ["/welcome", "/pwdchange", "/expired"],
        name: "Forgot",
        component: Forgot,
    },
    {
        path: "/changed",
        name: "Changed",
        component: Changed,
    },
    {
        path: "/error",
        name: "error",
        component: ErrorMsg,
        meta: {
            title: "QGistix Portal Error",
            auth: false,
        },
    },
    {
        path: "/report/:reportslug*",
        name: "report",
        component: Report,
        meta: {
            title: "QGistix Portal",
            auth: true,
        },
    },
    {
        path: "/native_report/:native_report_slug+",
        name: "native_report",
        component: NativeReport,
        meta: {
            title: "QGistix Portal",
            auth: true,
        },
    },
    {
        path: "/order/:program",
        name: "order",
        component: Order,
        meta: {
            title: "QGistix Portal",
            auth: true,
        },
    },
    {
        path: "/cod/:id*",
        name: "cod",
        component: COD,
        meta: {
            title: "QGistix COD Portal",
            auth: true,
        },
    },
    {
        path: "/codclient/:id",
        name: "codclient",
        component: COD,
        meta: { title: "QGistix Client COD Portal" },
    },
    {
        path: "/customReport/:reportName",
        name: "customReport",
        component: CustomReport,
        meta: {
            title: "QGistix Portal",
            auth: true,
        },
    },
    {
        path: "/docview/:key*",
        name: "DocView",
        component: DocView,
        meta: {
            title: "QGistix Portal",
            auth: true,
        },
    },
    {
        path: "/rmalabel",
        name: "rmalabel",
        component: RMALabel,
        meta: {
            title: "QGistix Portal",
            auth: true,
            roles: ["branch"],
        },
    },
    {
        path: "/csvorder",
        name: "csvorder",
        component: CSVOrder,
        meta: {
            title: "QGistix Portal",
            auth: true,
        },
    },
    {
        path: "/imageview/:qid*",
        name: "imageview",
        component: ImageView,
        meta: {
            title: "QGistix Portal",
            auth: true,
        },
    },
    {
        path: "/nexus/*",
        beforeEnter: () => window.location.href = "https://portal.qgistix.com/nexus",
    }],
});

router.beforeEach((to, from, next) => 
{
    // console.log("Router from:\n" + from.name + "\nto:\n" + to.name)

    // Use the page's router title to name the page
    if (to.meta && to.meta.title) 
    {
        document.title = to.meta.title;
    }

    // Redirect to the login page if not authenticated
    // for pages that have 'auth: true' set
    if (to.meta && to.meta.auth !== undefined) 
    {
        if (to.meta.auth) 
        {
            if (store.state.auth.isAuthenticated) 
            {
                let role = store.state.auth.profile["custom:role"];
                if (to.meta.roles && !to.meta.roles.includes(role)) 
                {
                    console.error("Invalid access: no matching role");
                    next(false); // caller does not have required role
                }
                else 
                {
                    next();
                }
            }
            else 
            {
                if (to.fullPath == "/") 
                {
                    // if we are just going to 'home' we don't pop up the auth form but just go to the login page
                    router.push({ name: "login" });
                } // we support deep links to auth-protected pages here
                else 
                {
                    console.log("Login needed before going to '" + to.fullPath + "'");
                    router.push({ name: "login" });
                }
            }
        } // auth defined as false
        else 
        {
            next();
        }
    } // no auth defined
    else 
    {
        next();
    }
});

export default router;
